import React from "react";
import { FormInputProps } from "../types";
import { Input } from "components/ui/input";


const FormInput = ({ field, value, onChange }: FormInputProps) => {
  const { id, name, label, type, placeholder, required, rows } = field;

  if (type === "textarea") {
    return (
      <div>
        <label
          htmlFor={id}
          className="block text-sm font-medium mb-1.5 sm:mb-2"
        >
          {label}
        </label>
        <textarea
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          rows={rows || 4}
          required={required}
          className="w-full px-3 py-2 border border-gray-200 bg-background rounded-lg focus:outline-none focus:ring-2 focus:ring-primary resize-none text-sm sm:text-base"
          placeholder={placeholder}
        />
      </div>
    );
  }

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium mb-1.5 sm:mb-2">
        {label}
      </label>
      <Input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="w-full px-3 py-2 rounded-lg"
        placeholder={placeholder}
      />
    </div>
  );
};

export default FormInput;
